// extracted by mini-css-extract-plugin
export var buttonContent = "_2o-0";
export var centered = "_2o-1";
export var centeredFlex = "_2o-2";
export var errorText = "_2o-3";
export var icon = "_2o-4";
export var iconButtonContent = "_2o-5";
export var monospace = "_2o-6";
export var padded = "_2o-7";